class DesentranhamentoDocumentoUrlBuilder {
	constructor(tipo) {
		this.PATH = tipo.path
	}

	getUrlCriarTermo(idDocumento) {
		return `api/${this.PATH}/documentos/${idDocumento}/gerar-termo-desentranhamento`
	}

	getUrlJuntarTermo(idDocumento) {
		return `api/${this.PATH}/documentos/${idDocumento}/processo-digital/termo-desentranhamento`
	}
}

export default DesentranhamentoDocumentoUrlBuilder
